<template>
  <div class="detail country-report">
    <div class="detail-banner">
      <div class="container banner-inner">
        <img v-if="country.icon" :src="country.icon" :alt="country.name" class="banner-flag" @error="onImgError" />
        <span v-else class="banner-flag-placeholder">{{ country.name.slice(0, 1) }}</span>
        <div class="banner-text">
          <h1>出海{{ country.name }}评估报告</h1>
          <div class="sub">政策 · 市场 · 投资全解析</div>
        </div>
      </div>
    </div>

    <div class="detail-body">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <div v-if="loading" class="empty-block">加载中…</div>

        <!-- 有报告：文档概述 + 查看完整文档 -->
        <div v-else-if="hasReport" class="report-body">
          <section class="case-block">
            <h3 class="block-title">文档概述</h3>
            <div class="rich-content" v-html="report.about"></div>
          </section>

          <button class="report-doc-btn" @click="openDoc">查看完整文档</button>
        </div>

        <!-- 无报告 -->
        <div v-else class="empty-block">当前国家评估报告整理中，即将呈现</div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchCountryList, fetchCountryReport } from '../api/home'

export default {
  name: 'CountryReport',
  props: ['id'],
  data () {
    return {
      country: { name: '国家', icon: '' },
      report: { content: '', about: '' },
      hasReport: false,
      loading: true
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      const countryId = this.id
      try {
        // 取国家名称与旗帜
        let baseName = '国家'
        let baseIcon = ''
        try {
          const groups = await fetchCountryList()
          const flat = groups.reduce((acc, g) => acc.concat(g.countries), [])
          const found = flat.find(c => String(c.id) === String(countryId))
          if (found) {
            baseName = found.name
            baseIcon = found.icon
          }
        } catch (e) { /* 兜底 */ }
        this.country = { name: baseName, icon: baseIcon }

        const report = await fetchCountryReport(countryId)
        this.report = report
        this.hasReport = !!(report.content || report.about)
      } catch (e) {
        this.hasReport = false
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    openDoc () {
      const url = this.report.content
      if (!url) {
        this.$toast.show({ message: '暂无可访问的完整文档', type: 'error' })
        return
      }
      if (url.indexOf('http') === 0) {
        window.open(url, '_blank')
      } else {
        this.$toast.show({ message: '该内容暂仅支持小程序内查看', type: 'error' })
      }
    },
    onImgError (e) {
      e.target.style.display = 'none'
    }
  }
}
</script>

<style scoped>
.banner-inner {
  flex-direction: row !important;
  align-items: center;
  gap: 18px;
}
.banner-flag {
  width: 64px;
  height: 64px;
  border-radius: 14px;
  object-fit: cover;
  background: #fff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  flex-shrink: 0;
}
.banner-flag-placeholder {
  width: 64px;
  height: 64px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
  font-size: 30px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.banner-text h1 {
  font-size: 28px;
  font-weight: 800;
}
.banner-text .sub {
  margin-top: 6px;
  font-size: 14px;
  opacity: 0.9;
}

.report-body {
  margin-top: 6px;
}
.rich-content {
  font-size: 15px;
  line-height: 1.9;
  color: var(--text-sub);
  word-break: break-word;
}
.rich-content >>> img {
  max-width: 100%;
  border-radius: 10px;
  margin: 12px 0;
}
.rich-content >>> p {
  margin: 0 0 14px;
}

.report-doc-btn {
  display: block;
  width: 100%;
  max-width: 420px;
  margin: 26px auto 0;
  height: 52px;
  border: none;
  border-radius: 12px;
  background: var(--primary);
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.25s ease;
}
.report-doc-btn:hover {
  background: var(--primary-dark);
}

.empty-block {
  text-align: center;
  color: var(--text-sub, #9aa6c0);
  padding: 50px 0;
  font-size: 15px;
}
</style>
